const W1000 = [
  {
      "id": 1,
      "word": "in",
      "pronunciation": "in",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 2,
      "word": "that",
      "pronunciation": "ˈðæt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 3,
      "word": "with",
      "pronunciation": "wɪθ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 4,
      "word": "this",
      "pronunciation": "ðəs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 5,
      "word": "do",
      "pronunciation": "dʉː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 6,
      "word": "as",
      "pronunciation": "æz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 7,
      "word": "at",
      "pronunciation": "æt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 8,
      "word": "she",
      "pronunciation": "ʃiː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 9,
      "word": "but",
      "pronunciation": "bʌt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 10,
      "word": "from",
      "pronunciation": "fɹɒm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 11,
      "word": "by",
      "pronunciation": "baɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 12,
      "word": "or",
      "pronunciation": "ɔː(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 13,
      "word": "say",
      "pronunciation": "seɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 14,
      "word": "go",
      "pronunciation": "ɡəʉ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 15,
      "word": "so",
      "pronunciation": "səʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 16,
      "word": "all",
      "pronunciation": "ɔːl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 17,
      "word": "one",
      "pronunciation": "wan",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 18,
      "word": "would",
      "pronunciation": "wʊd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 19,
      "word": "about",
      "pronunciation": "əˈbɛʊt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 20,
      "word": "can",
      "pronunciation": "ˈkæn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 21,
      "word": "which",
      "pronunciation": "wɪt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 22,
      "word": "there",
      "pronunciation": "ðeː(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 23,
      "word": "know",
      "pronunciation": "nəʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 24,
      "word": "more",
      "pronunciation": "ˈmɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 25,
      "word": "get",
      "pronunciation": "ɡɛt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 26,
      "word": "who",
      "pronunciation": "huː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 27,
      "word": "like",
      "pronunciation": "laɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 28,
      "word": "when",
      "pronunciation": "ʍɛn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 29,
      "word": "think",
      "pronunciation": "θɪŋk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 30,
      "word": "make",
      "pronunciation": "meɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 31,
      "word": "time",
      "pronunciation": "tɑem",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 32,
      "word": "see",
      "pronunciation": "siː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 33,
      "word": "what",
      "pronunciation": "wɔt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 34,
      "word": "some",
      "pronunciation": "sɐm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 35,
      "word": "other",
      "pronunciation": "ˈɐðə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 36,
      "word": "out",
      "pronunciation": "æɔt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 37,
      "word": "good",
      "pronunciation": "ɡʊ(d)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 38,
      "word": "people",
      "pronunciation": "ˈpiːpəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 39,
      "word": "year",
      "pronunciation": "jɪə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 40,
      "word": "take",
      "pronunciation": "teɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 41,
      "word": "well",
      "pronunciation": "wɛl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 42,
      "word": "because",
      "pronunciation": "bɪˈkɒz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 43,
      "word": "very",
      "pronunciation": "ˈvɛɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 44,
      "word": "just",
      "pronunciation": "d͡ʒʌst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 45,
      "word": "come",
      "pronunciation": "kʌm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 46,
      "word": "could",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 47,
      "word": "work",
      "pronunciation": "wɜːk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 48,
      "word": "use",
      "pronunciation":"yuz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 49,
      "word": "than",
      "pronunciation":"ðæn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 50,
      "word": "now",
      "pronunciation": "naʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 51,
      "word": "then",
      "pronunciation": "ðen",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 52,
      "word": "also",
      "pronunciation": "ˈɔːl.səʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 53,
      "word": "into",
      "pronunciation": "ˈɪn.tuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 54,
      "word": "only",
      "pronunciation": "ˈəʊn.li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 55,
      "word": "look",
      "pronunciation": "lʊk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 56,
      "word": "want",
      "pronunciation": "wɔnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 57,
      "word": "give",
      "pronunciation": "ɡɪv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 58,
      "word": "first",
      "pronunciation": "fɪrst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 59,
      "word": "new",
      "pronunciation": "njʉː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 60,
      "word": "way",
      "pronunciation": "weɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 61,
      "word": "find",
      "pronunciation": "faɪnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 62,
      "word": "over",
      "pronunciation":"ˈoʊ vər",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 63,
      "word": "any",
      "pronunciation": "ˈæni",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 64,
      "word": "after",
      "pronunciation": "ˈæf.tə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 65,
      "word": "day",
      "pronunciation": "deɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 66,
      "word": "where",
      "pronunciation": "wɛə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 67,
      "word": "thing",
      "pronunciation": "θɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 68,
      "word": "most",
      "pronunciation": "ˈməʊst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 69,
      "word": "should",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 70,
      "word": "need",
      "pronunciation": "niːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 71,
      "word": "much",
      "pronunciation": "mʌt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 72,
      "word": "right",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 73,
      "word": "how",
      "pronunciation": "hæŏ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 74,
      "word": "back",
      "pronunciation": "bæk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 75,
      "word": "mean",
      "pronunciation": "miːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 76,
      "word": "even",
      "pronunciation": "ˈiːvən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 77,
      "word": "may",
      "pronunciation": "meɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 78,
      "word": "here",
      "pronunciation": "hiːɹ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 79,
      "word": "many",
      "pronunciation": "ˈmæni",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 80,
      "word": "such",
      "pronunciation": "sʌt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 81,
      "word": "last",
      "pronunciation": "last",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 82,
      "word": "child",
      "pronunciation": "t͡ʃaɪld",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 83,
      "word": "tell",
      "pronunciation": "tɛl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 84,
      "word": "really",
      "pronunciation": "ˈɹɪəli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 85,
      "word": "call",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 86,
      "word": "before",
      "pronunciation": "bɪˈfɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 87,
      "word": "company",
      "pronunciation": "ˈkʌmp(ə)ni",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 88,
      "word": "through",
      "pronunciation": "θɹuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 89,
      "word": "down",
      "pronunciation": "daʊn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 90,
      "word": "show",
      "pronunciation": "ʃəʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 91,
      "word": "life",
      "pronunciation": "laɪf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 92,
      "word": "man",
      "pronunciation": "[mɛn]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 93,
      "word": "change",
      "pronunciation": "tʃeɪndʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 94,
      "word": "place",
      "pronunciation": "pleɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 95,
      "word": "long",
      "pronunciation": "ˈlɔːŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 96,
      "word": "between",
      "pronunciation": "bɪˈtwiːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 97,
      "word": "feel",
      "pronunciation": "fiːl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 98,
      "word": "too",
      "pronunciation": "tuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 99,
      "word": "still",
      "pronunciation": "stɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 100,
      "word": "problem",
      "pronunciation": "ˈpɹɒbləm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 101,
      "word": "write",
      "pronunciation": "ɹaɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 102,
      "word": "same",
      "pronunciation": "seɪm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 103,
      "word": "lot",
      "pronunciation": "lɒt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 104,
      "word": "great",
      "pronunciation": "ɡɹeɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 105,
      "word": "try",
      "pronunciation": "tɹaɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 106,
      "word": "leave",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 107,
      "word": "number",
      "pronunciation": "ˈnʌmbə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 108,
      "word": "both",
      "pronunciation": "bəʊθ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 109,
      "word": "own",
      "pronunciation": "ˈəʊn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 110,
      "word": "part",
      "pronunciation": "pɐːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 111,
      "word": "point",
      "pronunciation": "pɔɪnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 112,
      "word": "little",
      "pronunciation": "ˈlɪ.ɾɫ̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 113,
      "word": "help",
      "pronunciation": "hɛlp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 114,
      "word": "ask",
      "pronunciation": "ˈask",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 115,
      "word": "meet",
      "pronunciation": "miːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 116,
      "word": "start",
      "pronunciation": "stɑːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 117,
      "word": "talk",
      "pronunciation": "toːk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 118,
      "word": "something",
      "pronunciation": "ˈsamθɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 119,
      "word": "put",
      "pronunciation": "pʊt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 120,
      "word": "another",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 121,
      "word": "become",
      "pronunciation": "bəˈkʊm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 122,
      "word": "interest",
      "pronunciation": "ˈɪntəɹɪst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 123,
      "word": "country",
      "pronunciation": "ˈkɐntɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 124,
      "word": "old",
      "pronunciation": "ˈɒʊld",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 125,
      "word": "each",
      "pronunciation": "iːt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 126,
      "word": "school",
      "pronunciation": "skuːl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 127,
      "word": "late",
      "pronunciation": "leɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 128,
      "word": "high",
      "pronunciation": "haɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 129,
      "word": "different",
      "pronunciation": "ˈdɪf.(ə)ɹ.ənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 130,
      "word": "off",
      "pronunciation": "ɔːf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 131,
      "word": "next",
      "pronunciation": "nɛkst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 132,
      "word": "end",
      "pronunciation": "ɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 133,
      "word": "live",
      "pronunciation": "lɪv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 134,
      "word": "why",
      "pronunciation": "waɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 135,
      "word": "while",
      "pronunciation": "waɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 136,
      "word": "world",
      "pronunciation": "wɝld",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 137,
      "word": "week",
      "pronunciation": "wiːk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 138,
      "word": "play",
      "pronunciation": "pleɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 139,
      "word": "might",
      "pronunciation": "maɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 140,
      "word": "must",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 141,
      "word": "home",
      "pronunciation": "(h)əʊm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 142,
      "word": "never",
      "pronunciation": "ˈnɛv.ə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 143,
      "word": "include",
      "pronunciation": "ɪnˈkluːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 144,
      "word": "course",
      "pronunciation": "kɔːs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 145,
      "word": "house",
      "pronunciation": "hʌʊs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 146,
      "word": "report",
      "pronunciation": "ɹəˈpoːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 147,
      "word": "group",
      "pronunciation": "ɡɹuːp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 148,
      "word": "case",
      "pronunciation": "keɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 149,
      "word": "woman",
      "pronunciation": "ˈwʊmɘn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 150,
      "word": "around",
      "pronunciation": "əˈɹaʊnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 151,
      "word": "book",
      "pronunciation": "buːk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 152,
      "word": "family",
      "pronunciation": "ˈfɛm(ɘ)li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 153,
      "word": "seem",
      "pronunciation": "siːm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 154,
      "word": "let",
      "pronunciation": "lɛt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 155,
      "word": "again",
      "pronunciation": "əˈɡeɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 156,
      "word": "kind",
      "pronunciation": "kaɪnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 157,
      "word": "keep",
      "pronunciation": "kiːp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 158,
      "word": "hear",
      "pronunciation": "hɪə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 159,
      "word": "system",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 160,
      "word": "every",
      "pronunciation": "ˈɛv ri",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 161,
      "word": "question",
      "pronunciation": "ˈkwɛstjən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 162,
      "word": "during",
      "pronunciation": "ˈdjɔː.ɹɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 163,
      "word": "always",
      "pronunciation": "ˈɔː(l).weɪz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 164,
      "word": "big",
      "pronunciation": "bɪɡ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 165,
      "word": "set",
      "pronunciation": "sɛt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 166,
      "word": "small",
      "pronunciation": "smoːl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 167,
      "word": "study",
      "pronunciation": "ˈstʌdi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 168,
      "word": "follow",
      "pronunciation": "ˈfɒləʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 169,
      "word": "begin",
      "pronunciation": "biˈɡɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 170,
      "word": "important",
      "pronunciation": "ɪmˈpɔːtənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 171,
      "word": "since",
      "pronunciation": "sɪns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 172,
      "word": "run",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 173,
      "word": "under",
      "pronunciation": "ˈʊndə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 174,
      "word": "turn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 175,
      "word": "few",
      "pronunciation": "fjuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 176,
      "word": "bring",
      "pronunciation": "ˈbɹɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 177,
      "word": "early",
      "pronunciation": "ˈɜː.li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 178,
      "word": "hand",
      "pronunciation": "hænd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 179,
      "word": "state",
      "pronunciation": "steɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 180,
      "word": "move",
      "pronunciation": "muːv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 181,
      "word": "money",
      "pronunciation": "ˈmʌni",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 182,
      "word": "fact",
      "pronunciation": "fækt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 183,
      "word": "however",
      "pronunciation": "hɑʊˈɛvə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 184,
      "word": "area",
      "pronunciation": "ˈɛə̯ɹɪə̯",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 185,
      "word": "provide",
      "pronunciation": "pɹəˈvaɪd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 186,
      "word": "name",
      "pronunciation": "neɪm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 187,
      "word": "read",
      "pronunciation": "ɹiːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 188,
      "word": "friend",
      "pronunciation": "fɹɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 189,
      "word": "month",
      "pronunciation": "mʌnθ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 190,
      "word": "large",
      "pronunciation": "ˈlɑːd͡ʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 191,
      "word": "business",
      "pronunciation": "ˈbɪd.nəs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 192,
      "word": "without",
      "pronunciation": "wɪθˈʌʊt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 193,
      "word": "information",
      "pronunciation": "ˌɪnfəˈmeɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 194,
      "word": "open",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 195,
      "word": "order",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 196,
      "word": "government",
      "pronunciation": "ˈɡʌvə(n)mənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 197,
      "word": "word",
      "pronunciation": "wɜːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 198,
      "word": "issue",
      "pronunciation": "ˈɪsjuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 199,
      "word": "market",
      "pronunciation": "ˈmɑːkɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 200,
      "word": "pay",
      "pronunciation": "peɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 201,
      "word": "build",
      "pronunciation": "bɪld",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 202,
      "word": "hold",
      "pronunciation": "həʊld",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 203,
      "word": "service",
      "pronunciation": "ˈsɜːvɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 204,
      "word": "against",
      "pronunciation": "əˈɡeɪnst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 205,
      "word": "believe",
      "pronunciation": "bɪˈliːv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 206,
      "word": "second",
      "pronunciation": "ˈsɛkɪnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 207,
      "word": "though",
      "pronunciation": "ðəʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 208,
      "word": "yes",
      "pronunciation": "jɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 209,
      "word": "love",
      "pronunciation": "lʊv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 210,
      "word": "increase",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 211,
      "word": "job",
      "pronunciation": "d͡ʒɒb",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 212,
      "word": "plan",
      "pronunciation": "plæn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 213,
      "word": "result",
      "pronunciation": "ɹɪˈzʌlt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 214,
      "word": "away",
      "pronunciation": "əˈweɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 215,
      "word": "example",
      "pronunciation": "əɡˈzæmpl̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 216,
      "word": "happen",
      "pronunciation": "ˈhæpən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 217,
      "word": "offer",
      "pronunciation": "ˈɑfɚ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 218,
      "word": "young",
      "pronunciation": "jʌŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 219,
      "word": "close",
      "pronunciation": "kləʊz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 220,
      "word": "program",
      "pronunciation": "ˈpɹoʊˌɡɹæm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 221,
      "word": "lead",
      "pronunciation": "lɛd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 222,
      "word": "buy",
      "pronunciation": "baɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 223,
      "word": "understand",
      "pronunciation": "ˌɞndəɹˈstand",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 224,
      "word": "thank",
      "pronunciation": "[θaŋk]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 225,
      "word": "far",
      "pronunciation": "fɑː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 226,
      "word": "today",
      "pronunciation": "təˈdeɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 227,
      "word": "hour",
      "pronunciation": "ˈaʊɚ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 228,
      "word": "student",
      "pronunciation": "ˈstjuː.dənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 229,
      "word": "face",
      "pronunciation": "feɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 230,
      "word": "hope",
      "pronunciation": "həʊp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 231,
      "word": "idea",
      "pronunciation": "ɑeˈdiə̯",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 232,
      "word": "cost",
      "pronunciation": "ˈkɑst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 233,
      "word": "less",
      "pronunciation": "lɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 234,
      "word": "room",
      "pronunciation": "ɹuːm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 235,
      "word": "until",
      "pronunciation": "ənˈtɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 236,
      "word": "reason",
      "pronunciation": "ˈɹiːzən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 237,
      "word": "form",
      "pronunciation": "fɔːm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 238,
      "word": "spend",
      "pronunciation": "spɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 239,
      "word": "head",
      "pronunciation": "hɛd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 240,
      "word": "car",
      "pronunciation": "kɑː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 241,
      "word": "learn",
      "pronunciation": "lɜːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 242,
      "word": "level",
      "pronunciation": "ˈlɛv.əl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 243,
      "word": "person",
      "pronunciation": "ˈpɜːsən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 244,
      "word": "experience",
      "pronunciation": "ɪkˈspɪə.ɹɪəns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 245,
      "word": "once",
      "pronunciation": "wɒn(t)s",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 246,
      "word": "member",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 247,
      "word": "enough",
      "pronunciation": "iˈnʌf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 248,
      "word": "bad",
      "pronunciation": "bæːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 249,
      "word": "city",
      "pronunciation": "sɪtɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 250,
      "word": "night",
      "pronunciation": "naɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 251,
      "word": "able",
      "pronunciation": "ˈeɪ.bl̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 252,
      "word": "support",
      "pronunciation": "səˈpɔːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 253,
      "word": "whether",
      "pronunciation": "ˈwɛðə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 254,
      "word": "line",
      "pronunciation": "laɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 255,
      "word": "present",
      "pronunciation": "pɹəˈzɛnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 256,
      "word": "side",
      "pronunciation": "saɪd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 257,
      "word": "quite",
      "pronunciation": "kwaɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 258,
      "word": "although",
      "pronunciation": "ɔːlˈðəʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 259,
      "word": "sure",
      "pronunciation": "ʃoː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 260,
      "word": "term",
      "pronunciation": "tɜːm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 261,
      "word": "least",
      "pronunciation": "list",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 262,
      "word": "age",
      "pronunciation": "eɪd͡ʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 263,
      "word": "low",
      "pronunciation": "ləʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 264,
      "word": "speak",
      "pronunciation": "spiːk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 265,
      "word": "within",
      "pronunciation": "wɪˈθɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 266,
      "word": "process",
      "pronunciation": "ˈpɹoʊsɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 267,
      "word": "public",
      "pronunciation": "ˈpʌblɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 268,
      "word": "often",
      "pronunciation": "ˈɑf(t)ən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 269,
      "word": "train",
      "pronunciation": "tɹeɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 270,
      "word": "possible",
      "pronunciation": "ˈpɒsɪbl̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 271,
      "word": "actually",
      "pronunciation": "-ɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 272,
      "word": "rather",
      "pronunciation": "ˈɹɑːðə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 273,
      "word": "view",
      "pronunciation": "vjuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 274,
      "word": "together",
      "pronunciation": "təˈɡɛð.ə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 275,
      "word": "consider",
      "pronunciation": "kənˈsɪdə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 276,
      "word": "price",
      "pronunciation": "pɹaɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 277,
      "word": "parent",
      "pronunciation": "ˈpɛəɹənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 278,
      "word": "hard",
      "pronunciation": "hɑːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 279,
      "word": "party",
      "pronunciation": "ˈpɑ(ː)ɾi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 280,
      "word": "local",
      "pronunciation": "ˈləʊkl̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 281,
      "word": "control",
      "pronunciation": "kənˈtɹəʊl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 282,
      "word": "already",
      "pronunciation": "ɑlˈɹɛdi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 283,
      "word": "concern",
      "pronunciation": "kənˈsɜːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 284,
      "word": "product",
      "pronunciation": "ˈpɹɒd.əkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 285,
      "word": "lose",
      "pronunciation": "luːz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 286,
      "word": "story",
      "pronunciation": "ˈstɔː.ɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 287,
      "word": "almost",
      "pronunciation": "ɔːl.ˈməʊst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 288,
      "word": "continue",
      "pronunciation": "kənˈtɪnjuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 289,
      "word": "stand",
      "pronunciation": "stænd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 290,
      "word": "whole",
      "pronunciation": "həʊl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 291,
      "word": "yet",
      "pronunciation": "jɛt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 292,
      "word": "rate",
      "pronunciation": "ɹeɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 293,
      "word": "care",
      "pronunciation": "kɛə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 294,
      "word": "expect",
      "pronunciation": "ɛkˈspɛkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 295,
      "word": "effect",
      "pronunciation": "ɪˈfɛkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 296,
      "word": "sort",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 297,
      "word": "ever",
      "pronunciation": "ˈɛvə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 298,
      "word": "anything",
      "pronunciation": "ˈɛ.nə.θɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 299,
      "word": "cause",
      "pronunciation": "kɔːz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 300,
      "word": "fall",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 301,
      "word": "deal",
      "pronunciation": "diːl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 302,
      "word": "water",
      "pronunciation": "ˈwoːtə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 303,
      "word": "send",
      "pronunciation": "sɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 304,
      "word": "allow",
      "pronunciation": "əˈlaʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 305,
      "word": "soon",
      "pronunciation": "suːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 306,
      "word": "watch",
      "pronunciation": "wɒt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 307,
      "word": "base",
      "pronunciation": "beɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 308,
      "word": "probably",
      "pronunciation": "ˈpɹɒbli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 309,
      "word": "suggest",
      "pronunciation": "səˈdʒɛst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 310,
      "word": "past",
      "pronunciation": "pɑːst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 311,
      "word": "power",
      "pronunciation": "ˈpaʊ.ə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 312,
      "word": "test",
      "pronunciation": "test",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 313,
      "word": "visit",
      "pronunciation": "ˈvɪzɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 314,
      "word": "center",
      "pronunciation": "ˈsɛn.tə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 315,
      "word": "grow",
      "pronunciation": "ɡɹəʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 316,
      "word": "nothing",
      "pronunciation": "ˈnʌθɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 317,
      "word": "return",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 318,
      "word": "mother",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 319,
      "word": "walk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 320,
      "word": "matter",
      "pronunciation": "ˈmætə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 321,
      "word": "mind",
      "pronunciation": "maɪnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 322,
      "word": "value",
      "pronunciation": "ˈvæljuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 323,
      "word": "office",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 324,
      "word": "record",
      "pronunciation": "ˈɹɛkɔːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 325,
      "word": "stay",
      "pronunciation": "steɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 326,
      "word": "force",
      "pronunciation": "fɔːs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 327,
      "word": "stop",
      "pronunciation": "stɒp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 328,
      "word": "several",
      "pronunciation": "ˈsɛv(ə)ɹəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 329,
      "word": "light",
      "pronunciation": "lʌɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 330,
      "word": "develop",
      "pronunciation": "dɛˈvɛ.ləp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 331,
      "word": "remember",
      "pronunciation": "ɹɪˈmɛmbə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 332,
      "word": "bit",
      "pronunciation": "bɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 333,
      "word": "share",
      "pronunciation": "ʃɛə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 334,
      "word": "real",
      "pronunciation": "ɹiːl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 335,
      "word": "answer",
      "pronunciation": "ˈan.sə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 336,
      "word": "sit",
      "pronunciation": "sɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 337,
      "word": "figure",
      "pronunciation": "ˈfɪɡjɚ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 338,
      "word": "letter",
      "pronunciation": "-ɾə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 339,
      "word": "decide",
      "pronunciation": "dɪˈsaɪd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 340,
      "word": "language",
      "pronunciation": "[ˈleɪŋɡwɪd͡ʒ]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 341,
      "word": "subject",
      "pronunciation": "ˈsʌb.dʒɪkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 342,
      "word": "class",
      "pronunciation": "klas",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 343,
      "word": "development",
      "pronunciation": "dɪˈvɛləpmənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 344,
      "word": "town",
      "pronunciation": "taʊn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 345,
      "word": "half",
      "pronunciation": "hɑːf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 346,
      "word": "minute",
      "pronunciation": "ˈmɪnɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 347,
      "word": "food",
      "pronunciation": "fuːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 348,
      "word": "break",
      "pronunciation": "bɹeɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 349,
      "word": "clear",
      "pronunciation": "klɪə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 350,
      "word": "future",
      "pronunciation": "ˈfjuːt͡ʃə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 351,
      "word": "either",
      "pronunciation": "ˈaɪð.ə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 352,
      "word": "ago",
      "pronunciation": "əˈɡəʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 353,
      "word": "per",
      "pronunciation": "pɜː(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 354,
      "word": "remain",
      "pronunciation": "ɹɪˈmeɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 355,
      "word": "top",
      "pronunciation": "tɒp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 356,
      "word": "among",
      "pronunciation": "əˈmɒŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 357,
      "word": "win",
      "pronunciation": "wɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 358,
      "word": "color",
      "pronunciation": "ˈkʌl.ə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 359,
      "word": "involve",
      "pronunciation": "ɪnˈvɒlv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 360,
      "word": "reach",
      "pronunciation": "ɹiːt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 361,
      "word": "social",
      "pronunciation": "ˈsəʊʃəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 362,
      "word": "period",
      "pronunciation": "ˈpɪəɹɪəd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 363,
      "word": "across",
      "pronunciation": "əˈkɹɑs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 364,
      "word": "note",
      "pronunciation": "nəʊt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 365,
      "word": "history",
      "pronunciation": "ˈhɪst(ə)ɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 366,
      "word": "create",
      "pronunciation": "kɹiːˈeɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 367,
      "word": "drive",
      "pronunciation": "dɹaɪv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 368,
      "word": "along",
      "pronunciation": "əˈlɑŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 369,
      "word": "type",
      "pronunciation": "taɪp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 370,
      "word": "sound",
      "pronunciation": "saʊnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 371,
      "word": "eye",
      "pronunciation": "aɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 372,
      "word": "music",
      "pronunciation": "ˈmjuːzɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 373,
      "word": "game",
      "pronunciation": "ɡeɪm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 374,
      "word": "political",
      "pronunciation": "pəˈlɪtɪkəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 375,
      "word": "free",
      "pronunciation": "fɹiː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 376,
      "word": "receive",
      "pronunciation": "ɹɪˈsiːv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 377,
      "word": "moment",
      "pronunciation": "ˈməʊmənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 378,
      "word": "sale",
      "pronunciation": "seɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 379,
      "word": "policy",
      "pronunciation": "ˈpɒləsi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 380,
      "word": "further",
      "pronunciation": "fɜː(ɹ)ðə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 381,
      "word": "body",
      "pronunciation": "ˈbɒdi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 382,
      "word": "require",
      "pronunciation": "ɹɪˈkwaɪə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 383,
      "word": "wait",
      "pronunciation": "weɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 384,
      "word": "general",
      "pronunciation": "ˈd͡ʒɛnɹəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 385,
      "word": "appear",
      "pronunciation": "əˈpiːɹ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 386,
      "word": "toward",
      "pronunciation": "tɘ.ˈwoːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 387,
      "word": "team",
      "pronunciation": "tiːm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 388,
      "word": "easy",
      "pronunciation": "ˈiːzi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 389,
      "word": "individual",
      "pronunciation": "ˌɘndɘˈvɘd͡ʒɘl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 390,
      "word": "full",
      "pronunciation": "fʊl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 391,
      "word": "black",
      "pronunciation": "blak",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 392,
      "word": "sense",
      "pronunciation": "sɛn(t)s",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 393,
      "word": "perhaps",
      "pronunciation": "pəˈhæps",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 394,
      "word": "add",
      "pronunciation": "æd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 395,
      "word": "rule",
      "pronunciation": "ɹuːl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 396,
      "word": "pass",
      "pronunciation": "[pʰäːs]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 397,
      "word": "produce",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 398,
      "word": "sell",
      "pronunciation": "sɛl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 399,
      "word": "short",
      "pronunciation": "ʃoːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 400,
      "word": "agree",
      "pronunciation": "əˈɡɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 401,
      "word": "law",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 402,
      "word": "everything",
      "pronunciation": "ˈɛvɹiθɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 403,
      "word": "research",
      "pronunciation": "ɹɪˈsɜːtʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 404,
      "word": "cover",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 405,
      "word": "paper",
      "pronunciation": "ˈpeɪpə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 406,
      "word": "position",
      "pronunciation": "pəˈzɪʃ(ə)n",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 407,
      "word": "near",
      "pronunciation": "nɪə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 408,
      "word": "human",
      "pronunciation": "ˈhjuː.mən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 409,
      "word": "computer",
      "pronunciation": "kəmˈpjuːtə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 410,
      "word": "situation",
      "pronunciation": "sɪtjuːˈeɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 411,
      "word": "staff",
      "pronunciation": "ˈstæf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 412,
      "word": "activity",
      "pronunciation": "ækˈtɪ.və.ti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 413,
      "word": "film",
      "pronunciation": "[ˈfɪlm̩]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 414,
      "word": "morning",
      "pronunciation": "ˈmɔːnɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 415,
      "word": "war",
      "pronunciation": "wɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 416,
      "word": "account",
      "pronunciation": "ə.ˈkaʊnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 417,
      "word": "shop",
      "pronunciation": "ʃɒp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 418,
      "word": "major",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 419,
      "word": "someone",
      "pronunciation": "ˈsʌmwʌn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 420,
      "word": "above",
      "pronunciation": "əˈbʌv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 421,
      "word": "design",
      "pronunciation": "dɪˈzaɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 422,
      "word": "event",
      "pronunciation": "əˈvɛnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 423,
      "word": "special",
      "pronunciation": "ˈspɛ.ʃəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 424,
      "word": "sometimes",
      "pronunciation": "ˈsʌmtaɪmz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 425,
      "word": "condition",
      "pronunciation": "kənˈdɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 426,
      "word": "carry",
      "pronunciation": "ˈkæ.ɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 427,
      "word": "choose",
      "pronunciation": "t͡ʃuːz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 428,
      "word": "father",
      "pronunciation": "ˈfaːðə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 429,
      "word": "decision",
      "pronunciation": "dɪˈsɪʒən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 430,
      "word": "table",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 431,
      "word": "certain",
      "pronunciation": "ˈsɝtn̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 432,
      "word": "forward",
      "pronunciation": "ˈfoːwəd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 433,
      "word": "main",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 434,
      "word": "die",
      "pronunciation": "daɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 435,
      "word": "bear",
      "pronunciation": "bɛə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 436,
      "word": "cut",
      "pronunciation": "kʌt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 437,
      "word": "describe",
      "pronunciation": "dəˈskɹaɪb",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 438,
      "word": "himself",
      "pronunciation": "hɪmˈsɛlf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 439,
      "word": "available",
      "pronunciation": "əˈveɪləb(ə)l",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 440,
      "word": "especially",
      "pronunciation": "əˈspɛʃ(ə)li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 441,
      "word": "strong",
      "pronunciation": "stɹɑŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 442,
      "word": "rise",
      "pronunciation": "ɹaɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 443,
      "word": "girl",
      "pronunciation": "ɡɵːl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 444,
      "word": "maybe",
      "pronunciation": "ˈmeɪbi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 445,
      "word": "community",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 446,
      "word": "else",
      "pronunciation": "ɛls",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 447,
      "word": "particular",
      "pronunciation": "pəˈtɪkjələ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 448,
      "word": "role",
      "pronunciation": "ɹəʊl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 449,
      "word": "join",
      "pronunciation": "ˈdʒɔɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 450,
      "word": "difficult",
      "pronunciation": "ˈdɪfɪkəlt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 451,
      "word": "please",
      "pronunciation": "pliːz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 452,
      "word": "detail",
      "pronunciation": "ˈdiːteɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 453,
      "word": "difference",
      "pronunciation": "ˈdɪfəɹən(t)s",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 454,
      "word": "action",
      "pronunciation": "ˈæk.ʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 455,
      "word": "health",
      "pronunciation": "hɛlθ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 456,
      "word": "eat",
      "pronunciation": "iːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 457,
      "word": "step",
      "pronunciation": "stɛp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 458,
      "word": "true",
      "pronunciation": "tɹuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 459,
      "word": "phone",
      "pronunciation": "fəʊ̯n",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 460,
      "word": "themselves",
      "pronunciation": "ðəmˈsɛlvz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 461,
      "word": "draw",
      "pronunciation": "dɹɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 462,
      "word": "white",
      "pronunciation": "waɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 463,
      "word": "date",
      "pronunciation": "deɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 464,
      "word": "practice",
      "pronunciation": "ˈpɹæktɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 465,
      "word": "model",
      "pronunciation": "ˈmɒdl̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 466,
      "word": "raise",
      "pronunciation": "ɹeɪz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 467,
      "word": "customer",
      "pronunciation": "ˈkʌstəmə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 468,
      "word": "front",
      "pronunciation": "fɹʌnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 469,
      "word": "explain",
      "pronunciation": "ɛkˈspleɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 470,
      "word": "door",
      "pronunciation": "dɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 471,
      "word": "outside",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 472,
      "word": "behind",
      "pronunciation": "bəˈhaɪnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 473,
      "word": "economic",
      "pronunciation": "ˌiːkəˈnɒmɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 474,
      "word": "site",
      "pronunciation": "saɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 475,
      "word": "approach",
      "pronunciation": "əˈpɹəʊt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 476,
      "word": "teacher",
      "pronunciation": "ˈtiːt͡ʃə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 477,
      "word": "land",
      "pronunciation": "lænd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 478,
      "word": "charge",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 479,
      "word": "finally",
      "pronunciation": "ˈfaɪ.nəl.i",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 480,
      "word": "sign",
      "pronunciation": "saɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 481,
      "word": "claim",
      "pronunciation": "kleɪm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 482,
      "word": "relationship",
      "pronunciation": "ɹɪˈleɪʃ(ə)nʃɪp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 483,
      "word": "travel",
      "pronunciation": "ˈtɹævəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 484,
      "word": "enjoy",
      "pronunciation": "ənˈd͡ʒɔɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 485,
      "word": "death",
      "pronunciation": "diːθ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 486,
      "word": "nice",
      "pronunciation": "naɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 487,
      "word": "amount",
      "pronunciation": "əˈmaʊnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 488,
      "word": "improve",
      "pronunciation": "ɪmˈpɹuːv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 489,
      "word": "picture",
      "pronunciation": "ˈpɪktʃə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 490,
      "word": "boy",
      "pronunciation": "bɔːə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 491,
      "word": "regard",
      "pronunciation": "ɹɪˈɡɑːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 492,
      "word": "organization",
      "pronunciation": "ˌɔɹɡənaɪˈzeɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 493,
      "word": "happy",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 494,
      "word": "couple",
      "pronunciation": "ˈkʌpəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 495,
      "word": "act",
      "pronunciation": "æk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 496,
      "word": "range",
      "pronunciation": "ɹeɪndʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 497,
      "word": "quality",
      "pronunciation": "ˈkwɒlɪti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 498,
      "word": "project",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 499,
      "word": "round",
      "pronunciation": "ˈɹaʊnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 500,
      "word": "opportunity",
      "pronunciation": "ˌɒp.əˈtjuː.nɪ.tɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 501,
      "word": "road",
      "pronunciation": "ɹəʊd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 502,
      "word": "accord",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 503,
      "word": "list",
      "pronunciation": "lɪst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 504,
      "word": "wish",
      "pronunciation": "wɪʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 505,
      "word": "therefore",
      "pronunciation": "ˈðɛəfɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 506,
      "word": "wear",
      "pronunciation": "wɛə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 507,
      "word": "fund",
      "pronunciation": "ˈfʌnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 508,
      "word": "rest",
      "pronunciation": "ɹɛst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 509,
      "word": "kid",
      "pronunciation": "kɪd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 510,
      "word": "industry",
      "pronunciation": "ˈɪndəstɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 511,
      "word": "education",
      "pronunciation": "ˌɛdjʊˈkeɪʃn̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 512,
      "word": "measure",
      "pronunciation": "ˈmɛʒə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 513,
      "word": "kill",
      "pronunciation": "kɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 514,
      "word": "serve",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 515,
      "word": "likely",
      "pronunciation": "ˈlaɪkli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 516,
      "word": "certainly",
      "pronunciation": "ˈsɜːtn̩li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 517,
      "word": "national",
      "pronunciation": "ˈnæʃ(ə)nəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 518,
      "word": "itself",
      "pronunciation": "ɪtˈsɛlf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 519,
      "word": "teach",
      "pronunciation": "tiːt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 520,
      "word": "field",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 521,
      "word": "security",
      "pronunciation": "sɪˈkjɔːɹəti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 522,
      "word": "air",
      "pronunciation": "ˈɛə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 523,
      "word": "benefit",
      "pronunciation": "ˈbɛn.ɪ.fɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 524,
      "word": "trade",
      "pronunciation": "tɹeɪd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 525,
      "word": "risk",
      "pronunciation": "ɹɪsk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 526,
      "word": "news",
      "pronunciation": "njuːz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 527,
      "word": "standard",
      "pronunciation": "ˈstændəd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 528,
      "word": "vote",
      "pronunciation": "vəʊt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 529,
      "word": "percent",
      "pronunciation": "pəˈsɛnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 530,
      "word": "focus",
      "pronunciation": "ˈfəʊ.kəs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 531,
      "word": "stage",
      "pronunciation": "steɪd͡ʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 532,
      "word": "space",
      "pronunciation": "speɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 533,
      "word": "instead",
      "pronunciation": "ɪnˈstɛd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 534,
      "word": "realize",
      "pronunciation": "ˈɹɪə.laɪz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 535,
      "word": "usually",
      "pronunciation": "ˈjuːʒju(ə)li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 536,
      "word": "data",
      "pronunciation": "ˈdaetə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 537,
      "word": "single",
      "pronunciation": "ˈsɪŋɡəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 538,
      "word": "address",
      "pronunciation": "æˈdɹɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 539,
      "word": "performance",
      "pronunciation": "[pə.ˈfɔː.məns]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 540,
      "word": "chance",
      "pronunciation": "[tʃʰans]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 541,
      "word": "accept",
      "pronunciation": "ækˈsɛpt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 542,
      "word": "society",
      "pronunciation": "səˈsaɪ.ə.ti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 543,
      "word": "technology",
      "pronunciation": "tɛkˈnɒlədʒi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 544,
      "word": "mention",
      "pronunciation": "ˈmɛnʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 545,
      "word": "choice",
      "pronunciation": "tʃɔɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 546,
      "word": "save",
      "pronunciation": "seɪv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 547,
      "word": "common",
      "pronunciation": "ˈkɒmən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 548,
      "word": "culture",
      "pronunciation": "ˈkʌlt͡ʃə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 549,
      "word": "total",
      "pronunciation": "ˈtəʊ.təl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 550,
      "word": "demand",
      "pronunciation": "dɪˈmɑːnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 551,
      "word": "material",
      "pronunciation": "məˈtɪəɹɪəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 552,
      "word": "limit",
      "pronunciation": "ˈlɪmt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 553,
      "word": "listen",
      "pronunciation": "ˈlɪs.ən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 554,
      "word": "due",
      "pronunciation": "dʒʉː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 555,
      "word": "wrong",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 556,
      "word": "foot",
      "pronunciation": "[fʊt̚]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 557,
      "word": "effort",
      "pronunciation": "ˈɛfət",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 558,
      "word": "attention",
      "pronunciation": "əˈtɛn.ʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 559,
      "word": "upon",
      "pronunciation": "əˈpɒn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 560,
      "word": "check",
      "pronunciation": "t͡ʃɛk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 561,
      "word": "complete",
      "pronunciation": "kəmˈpliːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 562,
      "word": "lie",
      "pronunciation": "laɪ̯",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 563,
      "word": "pick",
      "pronunciation": "pɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 564,
      "word": "reduce",
      "pronunciation": "ɹɪˈdjuːs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 565,
      "word": "personal",
      "pronunciation": "ˈpɜː.sən.əl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 566,
      "word": "ground",
      "pronunciation": "ɡɹaʊnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 567,
      "word": "animal",
      "pronunciation": "ˈænɪməl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 568,
      "word": "arrive",
      "pronunciation": "əˈɹaɪv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 569,
      "word": "patient",
      "pronunciation": "ˈpeɪʃənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 570,
      "word": "current",
      "pronunciation": "ˈkʌɹənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 571,
      "word": "century",
      "pronunciation": "ˈsɛn.t͡ʃə.ɹiː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 572,
      "word": "evidence",
      "pronunciation": "[ˈɛvəɾəns]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 573,
      "word": "exist",
      "pronunciation": "ɪɡˈzɪst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 574,
      "word": "similar",
      "pronunciation": "ˈsɪmələ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 575,
      "word": "fight",
      "pronunciation": "[fʌɪt]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 576,
      "word": "leader",
      "pronunciation": "ˈlidɚ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 577,
      "word": "fine",
      "pronunciation": "fæːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 578,
      "word": "street",
      "pronunciation": "stɹiːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 579,
      "word": "former",
      "pronunciation": "ˈfɔːmə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 580,
      "word": "contact",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 581,
      "word": "particularly",
      "pronunciation": "pəˈtɪkjəli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 582,
      "word": "wife",
      "pronunciation": "waɪf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 583,
      "word": "sport",
      "pronunciation": "spɔːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 584,
      "word": "prepare",
      "pronunciation": "pɹɪˈpɛə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 585,
      "word": "discuss",
      "pronunciation": "dɪsˈkʊs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 586,
      "word": "response",
      "pronunciation": "ɹɪˈspɒns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 587,
      "word": "voice",
      "pronunciation": "vɔɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 588,
      "word": "piece",
      "pronunciation": "piːs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 589,
      "word": "finish",
      "pronunciation": "ˈfɪnɪʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 590,
      "word": "suppose",
      "pronunciation": "səˈpəʊz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 591,
      "word": "apply",
      "pronunciation": "əˈplaɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 592,
      "word": "president",
      "pronunciation": "ˈpɹɛzɨdənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 593,
      "word": "fire",
      "pronunciation": "ˈfɑeə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 594,
      "word": "compare",
      "pronunciation": "kəmˈpɛə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 595,
      "word": "court",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 596,
      "word": "police",
      "pronunciation": "[pəˈliːs]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 597,
      "word": "store",
      "pronunciation": "stɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 598,
      "word": "poor",
      "pronunciation": "poː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 599,
      "word": "knowledge",
      "pronunciation": "ˈnɒlɪdʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 600,
      "word": "laugh",
      "pronunciation": "laːf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 601,
      "word": "arm",
      "pronunciation": "ɑːm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 602,
      "word": "heart",
      "pronunciation": "hɑːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 603,
      "word": "source",
      "pronunciation": "sɔːs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 604,
      "word": "employee",
      "pronunciation": "(ˌ)ɪm-",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 605,
      "word": "manage",
      "pronunciation": "ˈmænɪdʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 606,
      "word": "simply",
      "pronunciation": "ˈsɪmpli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 607,
      "word": "bank",
      "pronunciation": "bæŋk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 608,
      "word": "firm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 609,
      "word": "cell",
      "pronunciation": "sɛl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 610,
      "word": "article",
      "pronunciation": "ˈɑːtɪkəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 611,
      "word": "fast",
      "pronunciation": "fɑːst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 612,
      "word": "attack",
      "pronunciation": "əˈtæk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 613,
      "word": "foreign",
      "pronunciation": "ˈfɒɹən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 614,
      "word": "surprise",
      "pronunciation": "səˈpɹaɪz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 615,
      "word": "feature",
      "pronunciation": "ˈfiːtʃə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 616,
      "word": "factor",
      "pronunciation": "ˈfæktə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 617,
      "word": "pretty",
      "pronunciation": "ˈpɹɪti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 618,
      "word": "recently",
      "pronunciation": "ˈɹiːsəntli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 619,
      "word": "affect",
      "pronunciation": "əˈfɛkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 620,
      "word": "drop",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 621,
      "word": "recent",
      "pronunciation": "ˈɹiːsənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 622,
      "word": "relate",
      "pronunciation": "ɹiˈleɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 623,
      "word": "official",
      "pronunciation": "əˈfɪʃəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 624,
      "word": "financial",
      "pronunciation": "faɪˈnænʃəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 625,
      "word": "miss",
      "pronunciation": "mɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 626,
      "word": "art",
      "pronunciation": "ɑːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 627,
      "word": "campaign",
      "pronunciation": "kæmˈpeɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 628,
      "word": "private",
      "pronunciation": "ˈpɹaɪvət",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 629,
      "word": "pause",
      "pronunciation": "pɔːz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 630,
      "word": "everyone",
      "pronunciation": "ˈɛv.ɹi.wʌn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 631,
      "word": "forget",
      "pronunciation": "fəˈɡɛt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 632,
      "word": "page",
      "pronunciation": "peɪd͡ʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 633,
      "word": "worry",
      "pronunciation": "ˈwɒɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 634,
      "word": "summer",
      "pronunciation": "ˈsʌmə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 635,
      "word": "drink",
      "pronunciation": "dɹɪŋk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 636,
      "word": "opinion",
      "pronunciation": "əˈpɪnjən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 637,
      "word": "park",
      "pronunciation": "[paːk]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 638,
      "word": "represent",
      "pronunciation": "ɹɛp.ɹɪ.ˈzɛnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 639,
      "word": "key",
      "pronunciation": "kiː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 640,
      "word": "inside",
      "pronunciation": "ɪnˈsaɪd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 641,
      "word": "manager",
      "pronunciation": "ˈmæn.ɪ.dʒə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 642,
      "word": "international",
      "pronunciation": "ˌɪntəˈnæʃ(ə)n(ə)l",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 643,
      "word": "contain",
      "pronunciation": "kənˈteɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 644,
      "word": "notice",
      "pronunciation": "ˈnəʊtɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 645,
      "word": "wonder",
      "pronunciation": "ˈwʌndə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 646,
      "word": "nature",
      "pronunciation": "ˈnæɪ̯tʃə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 647,
      "word": "structure",
      "pronunciation": "ˈstɹʌktʃə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 648,
      "word": "section",
      "pronunciation": "ˈsɛkʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 649,
      "word": "myself",
      "pronunciation": "maɪˈsɛlf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 650,
      "word": "exactly",
      "pronunciation": "ɪɡˈzæk(t)li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 651,
      "word": "plant",
      "pronunciation": "plænt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 652,
      "word": "paint",
      "pronunciation": "peɪnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 653,
      "word": "worker",
      "pronunciation": "ˈwɜː.kə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 654,
      "word": "press",
      "pronunciation": "pɹɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 655,
      "word": "whatever",
      "pronunciation": "wɒtˈɛvə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 656,
      "word": "necessary",
      "pronunciation": "ˈnɛsəsɹɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 657,
      "word": "region",
      "pronunciation": "ˈɹiːd͡ʒn̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 658,
      "word": "growth",
      "pronunciation": "ɡɹəʊθ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 659,
      "word": "evening",
      "pronunciation": "ˈivnɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 660,
      "word": "influence",
      "pronunciation": "ˈɪn.flu.əns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 661,
      "word": "respect",
      "pronunciation": "ɹɪˈspɛkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 662,
      "word": "various",
      "pronunciation": "ˈvɛə.ɹi.əs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 663,
      "word": "catch",
      "pronunciation": "kæt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 664,
      "word": "thus",
      "pronunciation": "ˈðʌs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 665,
      "word": "skill",
      "pronunciation": "skɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 666,
      "word": "attempt",
      "pronunciation": "əˈtɛmpt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 667,
      "word": "son",
      "pronunciation": "sɒn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 668,
      "word": "simple",
      "pronunciation": "ˈsɪmpəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 669,
      "word": "medium",
      "pronunciation": "ˈmiːdɪəm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 670,
      "word": "average",
      "pronunciation": "ˈævəɹɪd͡ʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 671,
      "word": "stock",
      "pronunciation": "stɒk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 672,
      "word": "management",
      "pronunciation": "ˈmænədʒmənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 673,
      "word": "character",
      "pronunciation": "ˈkæɹəktə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 674,
      "word": "bed",
      "pronunciation": "bed",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 675,
      "word": "hit",
      "pronunciation": "hɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 676,
      "word": "establish",
      "pronunciation": "ɪˈstæb.lɪʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 677,
      "word": "indeed",
      "pronunciation": "ɪnˈdiːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 678,
      "word": "final",
      "pronunciation": "ˈfaɪ.nəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 679,
      "word": "economy",
      "pronunciation": "iːˈkɒn.ə.mi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 680,
      "word": "fit",
      "pronunciation": "fɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 681,
      "word": "guy",
      "pronunciation": "ɡaɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 682,
      "word": "function",
      "pronunciation": "ˈfʌŋ(k)ʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 683,
      "word": "yesterday",
      "pronunciation": "ˈjɛstədeɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 684,
      "word": "image",
      "pronunciation": "ˈɪmɪd͡ʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 685,
      "word": "size",
      "pronunciation": "saɪz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 686,
      "word": "behavior",
      "pronunciation": "[bɪˈheɪvjə]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 687,
      "word": "addition",
      "pronunciation": "æˈdɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 688,
      "word": "determine",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 689,
      "word": "station",
      "pronunciation": "ˈsteɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 690,
      "word": "population",
      "pronunciation": "ˌpɒpjʊˈleɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 691,
      "word": "fail",
      "pronunciation": "feɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 692,
      "word": "environment",
      "pronunciation": "-mɪnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 693,
      "word": "production",
      "pronunciation": "pɹəˈdʌkʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 694,
      "word": "contract",
      "pronunciation": "ˈkɒntɹækt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 695,
      "word": "player",
      "pronunciation": "ˈpleɪə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 696,
      "word": "comment",
      "pronunciation": "ˈkɒmɛnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 697,
      "word": "enter",
      "pronunciation": "ˈɛntə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 698,
      "word": "occur",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 699,
      "word": "alone",
      "pronunciation": "əˈləʊn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 700,
      "word": "significant",
      "pronunciation": "sɪɡˈnɪ.fɪ.kənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 701,
      "word": "drug",
      "pronunciation": "dɹʌɡ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 702,
      "word": "wall",
      "pronunciation": "wɔːl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 703,
      "word": "series",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 704,
      "word": "direct",
      "pronunciation": "d(a)ɪˈɹɛkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 705,
      "word": "success",
      "pronunciation": "səkˈsɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 706,
      "word": "tomorrow",
      "pronunciation": "təˈmɔɹoʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 707,
      "word": "director",
      "pronunciation": "daɪˈɹɛktə(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 708,
      "word": "clearly",
      "pronunciation": "ˈkliːɹli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 709,
      "word": "lack",
      "pronunciation": "lak",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 710,
      "word": "review",
      "pronunciation": "ɹɪˈvjuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 711,
      "word": "depend",
      "pronunciation": "dɪˈpɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 712,
      "word": "race",
      "pronunciation": "ɹeɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 713,
      "word": "recognize",
      "pronunciation": "ˈɹɛkənaɪz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 714,
      "word": "window",
      "pronunciation": "ˈwɪndəʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 715,
      "word": "purpose",
      "pronunciation": "ˈpɜːpəs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 716,
      "word": "department",
      "pronunciation": "dɪˈpɑːtm(ə)nt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 717,
      "word": "gain",
      "pronunciation": "ɡeɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 718,
      "word": "tree",
      "pronunciation": "tɹiː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 719,
      "word": "college",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 720,
      "word": "argue",
      "pronunciation": "ˈɑː.ɡjuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 721,
      "word": "board",
      "pronunciation": "bɔːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 722,
      "word": "holiday",
      "pronunciation": "ˈhɒlɪdeɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 723,
      "word": "mark",
      "pronunciation": "mɑɹk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 724,
      "word": "church",
      "pronunciation": "t͡ʃɜːt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 725,
      "word": "machine",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 726,
      "word": "achieve",
      "pronunciation": "əˈtʃiːv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 727,
      "word": "item",
      "pronunciation": "[ˈaɪ̯ɾm̩]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 728,
      "word": "prove",
      "pronunciation": "pɹuːv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 729,
      "word": "cent",
      "pronunciation": "sɛnt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 730,
      "word": "season",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 731,
      "word": "floor",
      "pronunciation": "flɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 732,
      "word": "stuff",
      "pronunciation": "stʌf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 733,
      "word": "wide",
      "pronunciation": "wɑed",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 734,
      "word": "anyone",
      "pronunciation": "ˈæniˌwʌn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 735,
      "word": "method",
      "pronunciation": "ˈmɛθəd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 736,
      "word": "analysis",
      "pronunciation": "əˈnælɪsɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 737,
      "word": "election",
      "pronunciation": "ɪˈlɛkʃ(ə)n",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 738,
      "word": "military",
      "pronunciation": "ˈmɪl.ɪ.tɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 739,
      "word": "hotel",
      "pronunciation": "(h)əʊˈtɛl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 740,
      "word": "club",
      "pronunciation": "klʌb",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 741,
      "word": "below",
      "pronunciation": "bɪˈləʊ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 742,
      "word": "movie",
      "pronunciation": "ˈmuːvi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 743,
      "word": "doctor",
      "pronunciation": "ˈdɒktə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 744,
      "word": "discussion",
      "pronunciation": "dɪsˈkʊʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 745,
      "word": "sorry",
      "pronunciation": "ˈsɔɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 746,
      "word": "challenge",
      "pronunciation": "ˈtʃæl.əndʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 747,
      "word": "nation",
      "pronunciation": "ˈneɪ.ʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 748,
      "word": "nearly",
      "pronunciation": "ˈniːɹli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 749,
      "word": "statement",
      "pronunciation": "ˈsteɪtm(ə)nt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 750,
      "word": "link",
      "pronunciation": "lɪŋk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 751,
      "word": "despite",
      "pronunciation": "dɪˈspaɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 752,
      "word": "introduce",
      "pronunciation": "ˌɪntɹəˈdjuːs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 753,
      "word": "advantage",
      "pronunciation": "ədˈvɑːn.tɪdʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 754,
      "word": "ready",
      "pronunciation": "ˈɹɛdi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 755,
      "word": "marry",
      "pronunciation": "ˈmæɹɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 756,
      "word": "strike",
      "pronunciation": "stɹaɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 757,
      "word": "mile",
      "pronunciation": "maɪ̯l",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 758,
      "word": "seek",
      "pronunciation": "siːk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 759,
      "word": "ability",
      "pronunciation": "əˈ.bɪl.ɪ.ti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 760,
      "word": "unit",
      "pronunciation": "ˈjuː.nɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 761,
      "word": "card",
      "pronunciation": "kaːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 762,
      "word": "hospital",
      "pronunciation": "ˈhɒs.pɪ.tl̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 763,
      "word": "quickly",
      "pronunciation": "ˈkwɪkli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 764,
      "word": "interview",
      "pronunciation": "ˈɪntəvjuː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 765,
      "word": "agreement",
      "pronunciation": "əˈɡɹiːmənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 766,
      "word": "release",
      "pronunciation": "ɹɪˈliːs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 767,
      "word": "tax",
      "pronunciation": "tæks",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 768,
      "word": "solution",
      "pronunciation": "səˈl(j)uːʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 769,
      "word": "capital",
      "pronunciation": "ˈkæp.ɪ.təl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 770,
      "word": "popular",
      "pronunciation": "ˈpɒpjʊlə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 771,
      "word": "specific",
      "pronunciation": "spəˈsɪf.ɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 772,
      "word": "beautiful",
      "pronunciation": "ˈbjuːtɪfəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 773,
      "word": "fear",
      "pronunciation": "fɪə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 774,
      "word": "aim",
      "pronunciation": "eɪm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 775,
      "word": "television",
      "pronunciation": "ˈtɛləˌvɪʒən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 776,
      "word": "serious",
      "pronunciation": "ˈsɪə.ɹi.əs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 777,
      "word": "target",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 778,
      "word": "degree",
      "pronunciation": "dɪˈɡɹiː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 779,
      "word": "pull",
      "pronunciation": "pʊl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 780,
      "word": "red",
      "pronunciation": "ɹɛd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 781,
      "word": "husband",
      "pronunciation": "ˈhʌz.bənd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 782,
      "word": "access",
      "pronunciation": "ˈæksɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 783,
      "word": "movement",
      "pronunciation": "ˈmuːv.mənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 784,
      "word": "treat",
      "pronunciation": "tɹiːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 785,
      "word": "identify",
      "pronunciation": "aɪˈdɛn.tɪ.faɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 786,
      "word": "loss",
      "pronunciation": "lɑs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 787,
      "word": "shall",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 788,
      "word": "modern",
      "pronunciation": "ˈmɒd(ə)n",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 789,
      "word": "pressure",
      "pronunciation": "[ˈpɹɛʃ.ə(ɹ)]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 790,
      "word": "bus",
      "pronunciation": "bɐs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 791,
      "word": "treatment",
      "pronunciation": "ˈtɹiːtmənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 792,
      "word": "yourself",
      "pronunciation": "jɔːˈsɛlf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 793,
      "word": "supply",
      "pronunciation": "səˈplaɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 794,
      "word": "village",
      "pronunciation": "ˈvɪlɪd͡ʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 795,
      "word": "worth",
      "pronunciation": "wɜːθ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 796,
      "word": "natural",
      "pronunciation": "ˈnætʃəɹəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 797,
      "word": "express",
      "pronunciation": "ɛk.ˈspɹɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 798,
      "word": "indicate",
      "pronunciation": "ˈɪndɪkeɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 799,
      "word": "attend",
      "pronunciation": "əˈtɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 800,
      "word": "brother",
      "pronunciation": "ˈbɹɐðɘ(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 801,
      "word": "investment",
      "pronunciation": "ɪnˈvɛsmənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 802,
      "word": "score",
      "pronunciation": "skɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 803,
      "word": "organize",
      "pronunciation": "ˈɔːɡənaɪz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 804,
      "word": "trip",
      "pronunciation": "tɹɪp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 805,
      "word": "beyond",
      "pronunciation": "biˈjɒnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 806,
      "word": "sleep",
      "pronunciation": "sliːp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 807,
      "word": "fish",
      "pronunciation": "fɪʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 808,
      "word": "promise",
      "pronunciation": "ˈpɹɒmɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 809,
      "word": "potential",
      "pronunciation": "pəˈtɛnʃəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 810,
      "word": "energy",
      "pronunciation": "ˈɛnəd͡ʒi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 811,
      "word": "trouble",
      "pronunciation": "ˈtɹʌb(ə)l",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 812,
      "word": "relation",
      "pronunciation": "ɹɪˈleɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 813,
      "word": "touch",
      "pronunciation": "tʌtʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 814,
      "word": "file",
      "pronunciation": "faɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 815,
      "word": "middle",
      "pronunciation": "ˈmɪdəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 816,
      "word": "bar",
      "pronunciation": "bɑː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 817,
      "word": "suffer",
      "pronunciation": "ˈsʌfə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 818,
      "word": "strategy",
      "pronunciation": "ˈstɹætədʒi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 819,
      "word": "deep",
      "pronunciation": "diːp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 820,
      "word": "except",
      "pronunciation": "ɪkˈsɛpt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 821,
      "word": "clean",
      "pronunciation": "kleːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 822,
      "word": "tend",
      "pronunciation": "tɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 823,
      "word": "advance",
      "pronunciation": "ədˈvaːns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 824,
      "word": "fill",
      "pronunciation": "fɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 825,
      "word": "star",
      "pronunciation": "stɑː(ɹ)",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 826,
      "word": "network",
      "pronunciation": "nɛtwɜːk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 827,
      "word": "generally",
      "pronunciation": "d͡ʒɛn.əɹ.ə.li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 828,
      "word": "operation",
      "pronunciation": "ˌɒpəˈɹeɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 829,
      "word": "match",
      "pronunciation": "mæt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 830,
      "word": "avoid",
      "pronunciation": "əˈvɔɪd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 831,
      "word": "seat",
      "pronunciation": "siːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 832,
      "word": "throw",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 833,
      "word": "task",
      "pronunciation": "tɑːsk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 834,
      "word": "normal",
      "pronunciation": "ˈnɔːməl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 835,
      "word": "goal",
      "pronunciation": "ɡɒʊl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 836,
      "word": "associate",
      "pronunciation": "əˈsəʊsi.ət",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 837,
      "word": "blue",
      "pronunciation": "bluː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 838,
      "word": "positive",
      "pronunciation": "ˈpɒzɪ̈tɪv",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 839,
      "word": "option",
      "pronunciation": "ˈɒpʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 840,
      "word": "box",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 841,
      "word": "huge",
      "pronunciation": "[hʊudʒ]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 842,
      "word": "message",
      "pronunciation": "ˈmɛsɪd͡ʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 843,
      "word": "instance",
      "pronunciation": "ˈɪnstəns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 844,
      "word": "style",
      "pronunciation": "staɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 845,
      "word": "refer",
      "pronunciation": "ɹɪˈfɜː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 846,
      "word": "cold",
      "pronunciation": "kɔʊld",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 847,
      "word": "push",
      "pronunciation": "[pʷʊʃ]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 848,
      "word": "quarter",
      "pronunciation": "ˈkoː.tɘ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 849,
      "word": "assume",
      "pronunciation": "əˈsuːm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 850,
      "word": "baby",
      "pronunciation": "ˈbeɪbi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 851,
      "word": "successful",
      "pronunciation": "səkˈsɛsfl̩",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 852,
      "word": "sing",
      "pronunciation": "sɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 853,
      "word": "doubt",
      "pronunciation": "dʌʊt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 854,
      "word": "competition",
      "pronunciation": "ˌkɒmpəˈtɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 855,
      "word": "theory",
      "pronunciation": "ˈθiːəɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 856,
      "word": "propose",
      "pronunciation": "pɹəˈpəʊz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 857,
      "word": "reference",
      "pronunciation": "ˈɹɛf.(ə)ɹəns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 858,
      "word": "argument",
      "pronunciation": "ˈɑːɡjʊmənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 859,
      "word": "adult",
      "pronunciation": "əˈdʌlt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 860,
      "word": "fly",
      "pronunciation": "flaɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 861,
      "word": "document",
      "pronunciation": "ˈdɒkjʊmənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 862,
      "word": "pattern",
      "pronunciation": "ˈpat(ə)n",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 863,
      "word": "application",
      "pronunciation": "aplɪˈkeɪʃ(ə)n",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 864,
      "word": "hot",
      "pronunciation": "hɒt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 865,
      "word": "obviously",
      "pronunciation": "ˈɒ(b).vɪəs.li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 866,
      "word": "unclear",
      "pronunciation": "ʌnˈklɪɚ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 867,
      "word": "bill",
      "pronunciation": "bɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 868,
      "word": "search",
      "pronunciation": "sɜːt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 869,
      "word": "separate",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 870,
      "word": "central",
      "pronunciation": "ˈsɛntɹəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 871,
      "word": "career",
      "pronunciation": "kəˈɹɪə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 872,
      "word": "anyway",
      "pronunciation": "ˈɛniweɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 873,
      "word": "speech",
      "pronunciation": "ˈspiːtʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 874,
      "word": "dog",
      "pronunciation": "dɑɡ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 875,
      "word": "officer",
      "pronunciation": "ˈɑfɪsɚ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 876,
      "word": "throughout",
      "pronunciation": "θɹuˈʌʊt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 877,
      "word": "oil",
      "pronunciation": "ɔɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 878,
      "word": "dress",
      "pronunciation": "dɹɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 879,
      "word": "profit",
      "pronunciation": "ˈpɹɒfɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 880,
      "word": "guess",
      "pronunciation": "ɡɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 881,
      "word": "fun",
      "pronunciation": "fʊn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 882,
      "word": "protect",
      "pronunciation": "pɹəˈtɛkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 883,
      "word": "resource",
      "pronunciation": "ɹɪˈsɔɹs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 884,
      "word": "science",
      "pronunciation": "ˈsaɪəns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 885,
      "word": "disease",
      "pronunciation": "dɪˈziːz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 886,
      "word": "balance",
      "pronunciation": "ˈbæləns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 887,
      "word": "damage",
      "pronunciation": "ˈdæmɪdʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 888,
      "word": "basis",
      "pronunciation": "ˈbeɪsɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 889,
      "word": "author",
      "pronunciation": "ˈɔː.θə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 890,
      "word": "basic",
      "pronunciation": "ˈbeɪsɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 891,
      "word": "encourage",
      "pronunciation": "ɪnˈkʌɹɪdʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 892,
      "word": "hair",
      "pronunciation": "heː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 893,
      "word": "male",
      "pronunciation": "meɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 894,
      "word": "operate",
      "pronunciation": "ˈɒpəɹeɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 895,
      "word": "reflect",
      "pronunciation": "ɹɪˈflɛkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 896,
      "word": "exercise",
      "pronunciation": "ˈɛk.sə.saɪz",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 897,
      "word": "useful",
      "pronunciation": "ˈjuːsfəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 898,
      "word": "restaurant",
      "pronunciation": "ˈɹɛs.t(ə).ɹ(ə)nt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 899,
      "word": "income",
      "pronunciation": "ˈɪnˌkʌm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 900,
      "word": "property",
      "pronunciation": "ˈpɹɒp.ət.i",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 901,
      "word": "previous",
      "pronunciation": "ˈpɹiːvɪəs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 902,
      "word": "dark",
      "pronunciation": "dɑːk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 903,
      "word": "imagine",
      "pronunciation": "ɪˈmædʒ.ɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 904,
      "word": "okay",
      "pronunciation": "ˌəˈkæɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 905,
      "word": "earn",
      "pronunciation": "ɜːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 906,
      "word": "daughter",
      "pronunciation": "ˈdɑ.tɚ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 907,
      "word": "post",
      "pronunciation": "pəʊst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 908,
      "word": "newspaper",
      "pronunciation": "ˈnjuːsˌpeɪpə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 909,
      "word": "define",
      "pronunciation": "dɪˈfaɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 910,
      "word": "conclusion",
      "pronunciation": "kənˈkluːʒən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 911,
      "word": "clock",
      "pronunciation": "klɒk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 912,
      "word": "everybody",
      "pronunciation": "ˈɛvɹibɒdi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 913,
      "word": "weekend",
      "pronunciation": "wiːˈkɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 914,
      "word": "perform",
      "pronunciation": "pəˈfɔːm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 915,
      "word": "professional",
      "pronunciation": "pɹəˈfɛʃənəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 916,
      "word": "mine",
      "pronunciation": "maɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 917,
      "word": "debate",
      "pronunciation": "dɪˈbeɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 918,
      "word": "memory",
      "pronunciation": "ˈmɛm(ə)ɹi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 919,
      "word": "green",
      "pronunciation": "ɡɹiːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 920,
      "word": "song",
      "pronunciation": "sɒŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 921,
      "word": "object",
      "pronunciation": "ˈɒb.d͡ʒɛkt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 922,
      "word": "maintain",
      "pronunciation": "meɪnˈteɪn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 923,
      "word": "credit",
      "pronunciation": "ˈkɹɛdɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 924,
      "word": "ring",
      "pronunciation": "ɹɪŋ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 925,
      "word": "discover",
      "pronunciation": "dɪsˈkʊvə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 926,
      "word": "dead",
      "pronunciation": "diːd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 927,
      "word": "afternoon",
      "pronunciation": "af.təɾˈnʉːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 928,
      "word": "prefer",
      "pronunciation": "pɹɪˈfɜː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 929,
      "word": "extend",
      "pronunciation": "ɛkˈstɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 930,
      "word": "possibility",
      "pronunciation": "ˌpɒsɪˈbɪliti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 931,
      "word": "direction",
      "pronunciation": "d(a)ɪˈɹɛk.ʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 932,
      "word": "facility",
      "pronunciation": "fəˈsɪlɪti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 933,
      "word": "variety",
      "pronunciation": "vəˈɹaɪ.ɪ.ti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 934,
      "word": "daily",
      "pronunciation": "ˈdeɪli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 935,
      "word": "clothes",
      "pronunciation": "kləʊ(ð)z",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 936,
      "word": "screen",
      "pronunciation": "skɹiːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 937,
      "word": "track",
      "pronunciation": "tɹæk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 938,
      "word": "dance",
      "pronunciation": "[dæːns]",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 939,
      "word": "completely",
      "pronunciation": "kəmˈpliːtli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 940,
      "word": "female",
      "pronunciation": "ˈfiː.meɪl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 941,
      "word": "responsibility",
      "pronunciation": "ɹɪˌspɑnsəˈbɪlɪɾi",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 942,
      "word": "original",
      "pronunciation": "əˈɹɪdʒnəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 943,
      "word": "sister",
      "pronunciation": "ˈsɪs.tə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 944,
      "word": "rock",
      "pronunciation": "ɹɒk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 945,
      "word": "dream",
      "pronunciation": "dɹiːm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 946,
      "word": "nor",
      "pronunciation": "nɔː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 947,
      "word": "university",
      "pronunciation": "juːnɪˈvɜːsətiː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 948,
      "word": "easily",
      "pronunciation": "ˈiː.zə.liː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 949,
      "word": "agency",
      "pronunciation": "ˈeɪ.dʒən.si",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 950,
      "word": "dollar",
      "pronunciation": "dɔlɚ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 951,
      "word": "garden",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 952,
      "word": "fix",
      "pronunciation": "ˈfɪks",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 953,
      "word": "ahead",
      "pronunciation": "əˈhɛd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 954,
      "word": "cross",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 955,
      "word": "yeah",
      "pronunciation": "ˈjæ.ə",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 956,
      "word": "weight",
      "pronunciation": "weɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 957,
      "word": "legal",
      "pronunciation": "ˈliː.ɡəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 958,
      "word": "proposal",
      "pronunciation": "pɹəˈpəʊzəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 959,
      "word": "version",
      "pronunciation": "ˈvɜːʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 960,
      "word": "conversation",
      "pronunciation": "ˌkɒn.vəˈseɪ.ʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 961,
      "word": "somebody",
      "pronunciation": "ˈsʌmbədɪ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 962,
      "word": "pound",
      "pronunciation": "paʊnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 963,
      "word": "magazine",
      "pronunciation": "mæɡəˈziːn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 964,
      "word": "shape",
      "pronunciation": "ʃeɪp",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 965,
      "word": "sea",
      "pronunciation": "siː",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 966,
      "word": "immediately",
      "pronunciation": "əˈmiːdi.ətli",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 967,
      "word": "welcome",
      "pronunciation": "ˈwɛlkəm",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 968,
      "word": "smile",
      "pronunciation": "ˈsmaɪ.əl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 969,
      "word": "communication",
      "pronunciation": "kəˌmjuːnɪˈkeɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 970,
      "word": "agent",
      "pronunciation": "ˈeɪ.dʒənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 971,
      "word": "traditional",
      "pronunciation": "tɹəˈdɪʃnəl",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 972,
      "word": "replace",
      "pronunciation": "ɹɪˈpleɪs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 973,
      "word": "judge",
      "pronunciation": "d͡ʒʌd͡ʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 974,
      "word": "herself",
      "pronunciation": "hɜːˈsɛlf",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 975,
      "word": "suddenly",
      "pronunciation": "ˈsʌdn̩li",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 976,
      "word": "generation",
      "pronunciation": "ˌd͡ʒɛnəˈɹeɪʃən",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 977,
      "word": "estimate",
      "pronunciation": "ˈɛstɨmɨt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 978,
      "word": "favorite",
      "pronunciation": "ˈfeɪv.ɹɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 979,
      "word": "difficulty",
      "pronunciation": "ˈdɪfɪkəlti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 980,
      "word": "purchase",
      "pronunciation": "ˈpɜːtʃəs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 981,
      "word": "shoot",
      "pronunciation": "ʃuːt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 982,
      "word": "announce",
      "pronunciation": "əˈnaʊns",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 983,
      "word": "unless",
      "pronunciation": "ənˈlɛs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 984,
      "word": "independent",
      "pronunciation": "ɪndɪˈpɛndənt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 985,
      "word": "recommend",
      "pronunciation": "ɹɛkəˈmɛnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 986,
      "word": "survey",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 987,
      "word": "majority",
      "pronunciation": "məˈd͡ʒɒɹɪti",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 988,
      "word": "stick",
      "pronunciation": "stɪk",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 989,
      "word": "request",
      "pronunciation": "ɹɪˈkwɛst",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 990,
      "word": "rich",
      "pronunciation": "ɹɪt͡ʃ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 991,
      "word": "wind",
      "pronunciation": "ˈwaɪnd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 992,
      "word": "none",
      "pronunciation": "nɒn",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 993,
      "word": "exchange",
      "pronunciation": "ɛksˈtʃeɪndʒ",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 994,
      "word": "budget",
      "pronunciation": "ˈbʌdʒ.ɪt",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 995,
      "word": "famous",
      "pronunciation": "ˈfeɪməs",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 996,
      "word": "blood",
      "pronunciation": "blʊd",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 997,
      "word": "appropriate",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 998,
      "word": "block",
      "progress": [
          0,
          0,
          0
      ]
  },
  {
      "id": 999,
      "word": "warm",
      "pronunciation": "wɔːm",
      "progress": [
          0,
          0,
          0
      ]
  }

];
  export default W1000;




